import config from "utilities/config";

type Method = (
  "GET" |
  "HEAD" |
  "POST" |
  "PUT" |
  "DELETE" |
  "CONNECT" |
  "OPTIONS" |
  "TRACE" |
  "PATCH"
);

export interface WebFetchParams {
  url: string,
  body?: object,
  method: Method,
  onSuccess?: (data?: any) => void,
  onFailure?: (data?: any) => void,
  onInformation?: (data?: any) => void,
  onRedirect?: (data?: any) => void,
};

export const webFetch = async ({
    url,
    body,
    method,
    onSuccess,
    onFailure,
    onInformation,
    onRedirect,
  }: WebFetchParams) => {
  
  let response;
  let responseObj = null;

  // takes the data to call the callback with and a list of callbacks, calls the first callback that isn't null
  const callCallback = (data?: any, ...functions: ((data?: any) => void)[]) => {
    let firstNonNullCallback = functions.filter(f => f)[0];
    if (firstNonNullCallback) firstNonNullCallback(data);
  };
  
  if (url.indexOf("://") === -1) {
    url = config.webApiRoot + url;
  }

  try {
    let params: RequestInit = {
      headers: { "Content-Type": "application/json" },
      method: method,
      body: JSON.stringify(body),
    };
    
    response = await fetch(url, params);
    if (onSuccess)  responseObj = await response.json();
  } catch (e) {
    if (onFailure) callCallback(responseObj, onFailure);
  }

  if (!response) callCallback(undefined, onFailure);
  else {
    switch (`${response.status}`[0]) {
      case "1":
        callCallback(responseObj, onInformation, onFailure);
        break;
      case "2":
        callCallback(responseObj, onSuccess);
        break;
      case "3":
        callCallback(responseObj, onRedirect, onFailure);
        break;
      case "4":
      case "5":
        callCallback(responseObj, onFailure);
        break;
    }
  }
};
